import { render, staticRenderFns } from "./FAQAccountDelete.vue?vue&type=template&id=94992bea&scoped=true"
import script from "./FAQAccountDelete.vue?vue&type=script&lang=js"
export * from "./FAQAccountDelete.vue?vue&type=script&lang=js"
import style0 from "./FAQAccountDelete.vue?vue&type=style&index=0&id=94992bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94992bea",
  null
  
)

export default component.exports